export const locale = {
  lang: 'en',
  data: {
    'PROJECT': {
      'TITLE': 'Project',
      'DESC': 'Hello Project!'
    },
    'BUTTONS': {
      'NEWCUSTOMER': 'New Customer',
      'NEWINQUIRY': 'New Inquiry',
      'BACK': 'Back',
      'OfferPricePDF': 'Offer Price PDF',
    },
    'TITLE': {
      'MaterialPagination': 'Antal materialer pr. side',
    },
    'FILTERS': {
      'Filter': 'Search By Name , Number',
      'TEXTSEARCH': 'Search By Name',
      'NUMBERSEARCH': 'Number Search',
      'CustomerNumber': 'Customer Number',
      'CustomerName': 'Customer Name',
      'PhoneNumber': 'Phone Number',
      'Email': 'Email',
      'Address': 'Address',
      'City': 'City',
      'ZipCode': 'ZipCode',
      'Position': 'Position',
      'Text': 'Text',
      'Action': 'Action',
      'SORTING': 'Sort By',
      'Active': 'Include all Inactive',
      'BADGE': 'Inactive',
      'Deleted': 'Show Deleted',
      'OfferType': 'Offer Type',
      'All': 'All',
      'ShowOffer': 'Show Offer'
    },
    'MESSAGES': {
      'NORECORD': 'No Material Found',
      'SENDEMAILSUCCESS': 'Email sent successfully',
    },
    'materialReportStatus': {
      'value1': 'All             ',
      'value2': 'Stock Down ↓',
      'value3': 'Stock UP ↑',
      // 'value4': 'Shelf no (A-Z)',
      // 'value5': 'Shelf no (Z-A)',
    },
    'GridFeildsValue': {
      'MaterialNo': 'Material No',
      'Name': 'Name',
      'RetailPrice': 'Retail Price',
      'PurchasePrice': 'Purchase Price',
      'PersonalPrice': 'Personal Price',
      'Holdings': 'Stock',
      'MinHoldings': 'Min Stock',
      'MaxHoldings': 'Max Stock',
      'Unit': 'Unit',
      'ShelfNo': 'Shelf No',
      'Total': 'Total',
    },
    'SORTBY':
      [
        {
          Text: 'Name (A-Z)',
          Value: 'Text'
        },
        {
          Text: 'Name (Z-A)',
          Value: 'Text DESC'
        },
        {
          Text: 'Number (0-9)',
          Value: 'Number'
        },
        {
          Text: 'Number (9-0)',
          Value: 'Number DESC'
        },
        {
          Text: 'Shelf no (A-Z)',
          Value: 'ShelfNo'
        },
        {
          Text: 'Shelf no (Z-A)',
          Value: 'ShelfNo DESC'
        }
      ],
    'TOOTIPORTITLE': {
      'Material': 'Material'
    }
  }
};
